import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { BannerAPI } from '../api/banner/getbanner/bannerapi';
import { BannerRequest } from '../api/banner/getbanner/bannerrequest';
import { BannerResponse } from '../api/banner/getbanner/bannerresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { BannerAPIProcessorImpl } from '../processor/bannerapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { BannerSearchRequest } from '../api/banner/bannersearch/bannersearchrequest';
import { BannerSearchResponse } from '../api/banner/bannersearch/bannersearchresponse';
import { BannerSearchAPIProcessorImpl } from '../processor/bannersearchapiprocessor';
import { BannerSearchAPI } from '../api/banner/bannersearch/bannersearchapi';
import { GetBannerDetailsRequest } from '../api/banner/getbannerdetails/getbannerdetailsrequest';
import { GetBannerDetailsResponse } from '../api/banner/getbannerdetails/getbannerdetailsresponse';
import { GetBannerDetailsAPIProcessorImpl } from '../processor/getbannerdetailsapiprocessor';
import { GetBannerDetailsAPI } from '../api/banner/getbannerdetails/getbannerdetailsapi';
import { GetPlaylistRequest } from '../api/banner/getplaylist/getplaylistrequest';
import { GetPlaylistResponse } from '../api/banner/getplaylist/getplaylistresponse';
import { GetPlaylistAPIProcessorImpl } from '../processor/getplaylistapiprocessor';
import { GetPlaylistAPI } from '../api/banner/getplaylist/getplaylistapi';

export class BannerProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(BannerProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getBanners():APIProcessor<BannerRequest, BannerResponse>
    {
        this.logger.log("getBanners() invoked");
        return new BannerAPIProcessorImpl(this.getContext(), new BannerAPI(this.getHttpClient(), this.getContext()));
    }

    getBannerSearch():APIProcessor<BannerSearchRequest, BannerSearchResponse>
    {
        this.logger.log("getBannerSearch() invoked");
        return new BannerSearchAPIProcessorImpl(this.getContext(), new BannerSearchAPI(this.getHttpClient(), this.getContext()));
    }

    getGetBannerDetails():APIProcessor<GetBannerDetailsRequest, GetBannerDetailsResponse>
    {
        this.logger.log("getGetBannerDetails() invoked");
        return new GetBannerDetailsAPIProcessorImpl(this.getContext(), new GetBannerDetailsAPI(this.getHttpClient(), this.getContext()));
    }

    getPlaylistWhenBannerTypeIsMusicBox():APIProcessor<GetPlaylistRequest, GetPlaylistResponse>
    {
        this.logger.log("getPlaylistWhenBannerTypeIsMusicBox() invoked");
        return new GetPlaylistAPIProcessorImpl(this.getContext(), new GetPlaylistAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/bannerprocessorfactory.tsx